/* tslint:disable */
export function idiv(value: number, tileSize: number): number {
    return (value / tileSize) | 0;
}

/* tslint:enable */

/**
 * Constrain a value between minValue and MaxValue (inclusive)
 * @param value
 * @param minValue
 * @param maxValue
 * @returns
 */
export function clamp(value: number, minValue: number, maxValue: number): number {
    return Math.min(maxValue, Math.max(value, minValue));
}

/**
 * Rounds an integer down
 * @param value Must be integer
 * @returns
 */
export function floor(value: number): number {
    return value | 0;
}

/** checks if a set of 1d lines overlap */
export function overlapLine(min1: number, max1: number, min2: number, max2: number): number {
    return Math.max(0, Math.min(max1, max2) - Math.max(min1, min2));
}

export function overlapPt(pt: number, min1: number, max1: number): boolean {
    return min1 <= pt && max1 >= pt;
}

/** Checks if a point is inside a rect.
 * Given a rect 1x1 rect at 0,0 (left=0, right=1, top=0, bottom=1) returns true for all coords from x=[0,1) && y=[0,1)
 */
export function ptIntersectsRect(
    x: number,
    y: number,
    rectLeft: number,
    rectTop: number,
    rectRight: number,
    rectBottom: number,
): boolean {
    return x >= rectLeft && x < rectRight && y >= rectTop && y < rectBottom;
}

/** Check for overlap in rectangles. */
export function rectsOverlap(
    ax1: number,
    ax2: number,
    ay1: number,
    ay2: number,
    bx1: number,
    bx2: number,
    by1: number,
    by2: number,
): boolean {
    return ax1 < bx2 && bx1 < ax2 && ay1 < by2 && by1 < ay2;
}

/** Return random number x where 0 <= x <= max */
export function rngIntMax(max: number): number {
    return rngInt(0, max);
}

/** Return random number x where min <= x <= max */
export function rngInt(min: number, max: number): number {
    return Math.min(max, Math.floor(rng(min, max + 1)));
}

/** Return random number up to max*/
export function rngMax(max: number): number {
    return rng(0, max);
}

export function rng(min: number, max: number): number {
    return Math.random() * (max - min) + min;
}

export function rngBool(): boolean {
    return Math.random() < 0.5;
}
